

































































































































































































































































































































































































































































































































































































































































































































































































































































































































import TitleBarModule from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/ru";

import { STORE_KEY, store } from "./_store";
import { isObject } from "lodash";
import { saveAs } from "file-saver";
import {
  buildThermizationWorkbook,
  buildThermizationDoc,
  thermizationFilename,
} from "./thermizationXlsx";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading_category",
      "loaded_category",
      "consts",
      "lastShifts",
      "shiftWorkersList",
      "saveThermizationLoading",
      "printThermizationLoading",
      "historyList",
      "historyLoading",
    ]),
    ...mapState("ubic", ["actor"]),
    lastShiftsOptions(): { value: any; text: string }[] {
      return ((this as any).lastShifts || []).map((s: any) => {
        const id = s.id?.pk != null ? s.id : s.id;
        const lineName = s.line_name || "—";
        const dateStr = s.shift_date
          ? moment(s.shift_date).format("DD.MM.YYYY")
          : "";
        return { value: id, text: `${lineName} ${dateStr}`.trim() };
      });
    },
    canSaveThermization(): boolean {
      const m = (this as any).saveMeta;
      return !!(
        m.calculation_datetime &&
        m.line_id &&
        m.shift_id &&
        (this as any).input.after_product
      );
    },
    mastersForCombobox(): { id: any; label: string }[] {
      const list = (this as any).shiftWorkersList || [];
      return list
        .filter((w: any) => w.is_manager)
        .map((w: any) => ({
          id: w.employee_id,
          label: w.employee_name || "—",
        }));
    },
    preparedByForCombobox(): { id: any; label: string }[] {
      const list = (this as any).shiftWorkersList || [];
      return list
        .filter((w: any) => !w.is_manager)
        .map((w: any) => ({
          id: w.employee_id,
          label: w.employee_name || "—",
        }));
    },
    historyTableData(): any[] {
      return Array.isArray((this as any).historyTableRows)
        ? (this as any).historyTableRows
        : [];
    },
    historyDefaultSort(): [string, string] {
      return [
        (this as any).historySortField || "saved_at",
        (this as any).historySortOrder || "desc",
      ];
    },
    /** YYYY-MM-DD для фильтра смен в Combobox; без валидной даты — undefined (список не грузится). */
    shiftDateRelFilter(): string | undefined {
      const dt = (this as any).saveMeta?.calculation_datetime;
      if (dt == null) return undefined;
      const m = moment(dt);
      if (!m.isValid()) return undefined;
      return m.format("YYYY-MM-DD");
    },
    shiftPickerDisabled(): boolean {
      return !(this as any).shiftDateRelFilter;
    },
    shiftWorkersPickersDisabled(): boolean {
      const id = (this as any).saveMeta?.shift_id;
      if (id == null || id === "") return true;
      return false;
    },
  },
  methods: {
    ...mapActions(STORE_KEY, ["recalcCategory"]),
    formatHistoryField(row: any, field: string): string {
      if (!row) return "—";
      const val = row[field] ?? (row.values && row.values[field]);
      return val != null && String(val).trim() !== "" ? String(val) : "—";
    },
    /** История: время из saved_at (сервер в UTC) — показываем в локальной зоне браузера. */
    formatHistoryDateTime(row: any): string {
      if (!row) return "—";
      const val = row.saved_at ?? (row.values && row.values.saved_at);
      if (val == null) return "—";
      const m = moment.utc(val);
      if (!m.isValid()) return "—";
      return m.local().format("DD.MM.YYYY HH:mm");
    },
    onHistoryFilterModelChange() {
      const c = this as any;
      c.historyPage = 1;
      c.loadHistoryNow();
    },
    onHistoryDateChange() {
      const c = this as any;
      c.historyPage = 1;
      c.loadHistoryNow();
    },
    buildHistoryQuery() {
      const c = this as any;
      return {
        ...c.historyFilters,
        page: c.historyPage,
        page_size: c.historyPerPage,
        sort_field: c.historySortField,
        sort_order: c.historySortOrder,
      };
    },
    loadHistoryNow() {
      const c = this as any;
      this.$store
        .dispatch(`${STORE_KEY}/loadHistory`, c.buildHistoryQuery())
        .then((res: any) => {
          const list = res?.list;
          const meta = res?.meta || {};
          c.historyTableRows = Array.isArray(list) ? list : [];
          c.historyTotal =
            meta.total_count != null
              ? meta.total_count
              : c.historyTableRows.length;
          if (meta.page != null) c.historyPage = meta.page;
        });
    },
    onHistoryPageChange(page: number) {
      const c = this as any;
      c.historyPage = page;
      c.loadHistoryNow();
    },
    onHistorySort(field: string, order: string) {
      const c = this as any;
      c.historySortField = field || "saved_at";
      c.historySortOrder = order === "asc" ? "asc" : "desc";
      c.historyPage = 1;
      c.loadHistoryNow();
    },
    onWorkOrderSelect(selected: any) {
      const c = this as any;
      const name = selected?.name ?? selected?.label ?? null;
      c.saveMeta = { ...c.saveMeta, work_order_name: name };
    },
    onShiftSelectObject(selected: any) {
      const c = this as any;
      const label =
        selected?.shift_label ?? selected?.label ?? selected?.name ?? null;
      c.saveMeta = { ...c.saveMeta, shift_label: label };
    },
    onMasterSelect(selected: any) {
      const c = this as any;
      const name = selected?.label ?? selected?.name ?? null;
      c.saveMeta = { ...c.saveMeta, master_name: name };
    },
    onShiftSelect(shiftId: any) {
      const c = this as any;
      if (process.env.NODE_ENV === "development") {
        console.debug("[Calculator] onShiftSelect shift_id=", shiftId);
      }
      this.$store
        .dispatch(`${STORE_KEY}/loadShiftWorkers`, shiftId)
        .then(() => {
          const workers = c.shiftWorkersList || [];
          const master = workers.find((w: any) => w.is_manager);
          c.saveMeta = {
            ...c.saveMeta,
            master_employee_id:
              master && master.employee_id ? master.employee_id : null,
            prepared_by_employee_ids: [],
          };
        });
    },
    onReleaseRowInput(idx: number) {
      const rows = (this as any).releaseRows;
      if (idx !== rows.length - 1) return;
      const row = rows[idx];
      if (!row) return;
      const hasValue =
        String(row.product_name || "").trim() !== "" ||
        (row.net_kg != null && !Number.isNaN(Number(row.net_kg))) ||
        (row.quantity_pcs != null && !Number.isNaN(Number(row.quantity_pcs)));
      if (hasValue) {
        (this as any).releaseRows = [
          ...rows,
          { product_name: "", net_kg: null, quantity_pcs: null },
        ];
        if (process.env.NODE_ENV === "development") {
          console.debug(
            "[Calculator] release row added, total",
            (this as any).releaseRows.length,
          );
        }
      }
    },
    getReleaseRowsFiltered(): Array<{
      product_name: string;
      net_kg: number | null;
      quantity_pcs: number | null;
    }> {
      const rows = (this as any).releaseRows || [];
      return rows.filter((r: any) => {
        const a = String(r.product_name || "").trim();
        const hasNet = r.net_kg != null && !Number.isNaN(Number(r.net_kg));
        const hasQty =
          r.quantity_pcs != null && !Number.isNaN(Number(r.quantity_pcs));
        return a !== "" || hasNet || hasQty;
      });
    },
    saveThermization() {
      if (!(this as any).canSaveThermization) return;
      const c = this as any;
      const releaseRowsFiltered = c.getReleaseRowsFiltered();
      if (process.env.NODE_ENV === "development") {
        console.debug(
          "[Calculator] saveThermization release_rows count",
          releaseRowsFiltered.length,
        );
      }
      this.$store
        .dispatch(`${STORE_KEY}/saveThermizationAction`, {
          saveMeta: {
            ...c.saveMeta,
            release_batch_number: c.releaseBatchNumber || null,
            release_rows: releaseRowsFiltered,
          },
          product_after_id: (this as any).input.after_product?.id,
          calculation_input: (this as any).input,
          calculation_result: (this as any).result,
        })
        .then(() => {
          this.$buefy.toast.open({
            message: "Расчёт сохранён",
            type: "is-success",
          });
        })
        .catch((err: any) => {
          this.$buefy.toast.open({
            message: err?.message || "Ошибка сохранения",
            type: "is-danger",
          });
        });
    },
    printThermization() {
      if (!(this as any).canSaveThermization) return;
      const c = this as any;
      if (process.env.NODE_ENV === "development") {
        console.debug("[Calculator] printThermization click");
      }
      this.$store.commit(`${STORE_KEY}/SET_PRINT_THERMIZATION_LOADING`, true);
      const releaseRowsFilteredPrint = c.getReleaseRowsFiltered();
      this.$store
        .dispatch(`${STORE_KEY}/saveThermizationAction`, {
          saveMeta: {
            ...c.saveMeta,
            release_batch_number: c.releaseBatchNumber || null,
            release_rows: releaseRowsFilteredPrint,
          },
          product_after_id: c.input.after_product?.id,
          calculation_input: c.input,
          calculation_result: c.result,
        })
        .then((saved: any) => {
          const rawId =
            saved?.id ??
            saved?.pk ??
            saved?.document?.id ??
            saved?.document?.pk;
          if (rawId == null) {
            return Promise.reject(
              new Error("Сохранение прошло, но не получен id документа"),
            );
          }
          const saveId =
            typeof rawId === "string" && rawId.startsWith("d:")
              ? rawId
              : `d:thermization_calculation_saves:${rawId}`;
          return this.$store.dispatch(
            `${STORE_KEY}/getThermizationDocumentAction`,
            { id: saveId },
          );
        })
        .then((document: any) => {
          console.log("document => ", document);
          (this as any).downloadHistoryRow(document);
        })
        .catch((err: any) => {
          if (process.env.NODE_ENV === "development") {
            console.debug("[Calculator] printThermization error", err);
          }
          const details =
            err?.message ||
            (typeof err === "string" ? err : undefined) ||
            (err != null ? JSON.stringify(err) : undefined);
          console.error(
            "[Calculator] printThermization error details:",
            details,
          );
        })
        .finally(() => {
          this.$store.commit(
            `${STORE_KEY}/SET_PRINT_THERMIZATION_LOADING`,
            false,
          );
        });
    },
    getHistoryRowId(row: any): string | number | null {
      if (!row) return null;
      const id = row.id;
      if (id == null) return null;
      if (typeof id === "object" && id.pk != null) return id.pk;
      if (typeof id === "string") return id;
      return id;
    },
    downloadHistoryRow(row: any) {
      const docId = (this as any).getHistoryRowId(row);
      if (docId == null) {
        console.warn("[Calculator] downloadHistoryRow: Нет id записи", { row });
        return;
      }
      const saveId =
        typeof docId === "string" && docId.startsWith("d:")
          ? docId
          : `d:thermization_calculation_saves:${docId}`;
      (this as any).historyDownloadingId = docId;
      if (process.env.NODE_ENV === "development") {
        console.debug("[Calculator] downloadHistoryRow id=", saveId);
      }
      this.$store
        .dispatch(`${STORE_KEY}/getThermizationDocumentAction`, { id: saveId })
        .then((document: any) => {
          console.log("getThermizationDocumentAction => ", document);
          const doc = buildThermizationDoc(null, { document, row });
          return buildThermizationWorkbook(doc).then((buffer) => {
            const blob = new Blob([buffer], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const filename = thermizationFilename(doc);
            console.debug("[Calculator] downloadHistoryRow XLSX:", {
              bufferBytes: buffer?.byteLength,
              filename,
            });
            saveAs(blob, filename);
            this.$buefy.toast.open({
              message: "Файл выгружен",
              type: "is-success",
            });
          });
        })
        .catch((err: any) => {
          if (process.env.NODE_ENV === "development") {
            console.debug("[Calculator] downloadHistoryRow error", err);
          }
          const details =
            err?.message ||
            (typeof err === "string" ? err : undefined) ||
            (err != null ? JSON.stringify(err) : undefined);
          console.error(
            "[Calculator] downloadHistoryRow error details:",
            details,
          );
        })
        .finally(() => {
          (this as any).historyDownloadingId = null;
        });
    },
  },
  components: {
    TitleBar: TitleBarModule,
  },
})
export default class Calculator extends Vue {
  actor!: any;
  filter!: any;
  employees!: any[];
  consts!: any;

  activeTab: any = 0;

  input: any = {
    before_product: null,
    after_product: null,
    weight: 0,
    p_add_milkstab: 0,
    common_weight: 0,
    pallet_weight: 14.6,
    reprocessing_weight: 0,
    backet_1_class: 0,
    backet_2_class: 0,
    backet_3_class: 0,
    backet_4_class: 0,
    backet_5_class: 0,
    backet_6_class: 0,
    backet_7_class: 0,
    p_starch_before: 0,
    p_mix_before: 0,
    p_starch: 0,
    p_mix: 0,
    p_salt: 0,
    p_soda: 0,
    p_sugar: 0,
    p_butter: 0,
  };

  card_classes: any = {
    simple: "",
    p: "has-background-white-ter",
    g: "has-background-white-bis",
  };

  resultMilkstab: any = null;
  result: any = null;
  is_first: boolean = false;

  saveMeta: any = {
    work_order_id: null,
    work_order_name: null,
    calculation_datetime: null,
    line_id: null,
    shift_id: null,
    shift_label: null,
    master_employee_id: null,
    master_name: null,
    prepared_by_employee_ids: [],
    comment: "",
  };

  releaseBatchNumber: string = "";
  releaseRows: Array<{
    product_name: string;
    net_kg: number | null;
    quantity_pcs: number | null;
  }> = [{ product_name: "", net_kg: null, quantity_pcs: null }];

  historyFilters: any = {
    since: null,
    until: null,
    product_after_id: null,
    line_id: null,
    saved_by_id: null,
    work_order_id: null,
  };

  historyPage = 1;
  historyPerPage = 10;
  historyTotal = 0;
  historySortField = "saved_at";
  historySortOrder: "asc" | "desc" = "desc";

  historyTableRows: any[] = [];
  historyDownloadingId: string | number | null = null;
  showReleaseSection: boolean = false;

  get titleStack() {
    return ["Калькулятор"];
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.initializeDefaultsForNewForm();
  }

  private async initializeDefaultsForNewForm() {
    const c = this as any;
    if (!c.saveMeta?.calculation_datetime) {
      c.saveMeta = {
        ...c.saveMeta,
        calculation_datetime: moment().toDate(),
      };
      if (process.env.NODE_ENV === "development") {
        console.debug("[Calculator] default calculation_datetime set to today");
      }
    }

    await Promise.all([
      this.ensureDefaultWorkOrder(),
      this.ensureDefaultAtomLine(),
    ]);
  }

  private async ensureDefaultWorkOrder() {
    const c = this as any;
    if (c.saveMeta?.work_order_id) return;
    const QNAME = "CALC_DEFAULT_WORK_ORDER";
    try {
      const result = await (this as any).$db([
        (this as any)
          .$q(QNAME)
          .select()
          .fileds({
            id: "voc_work_orders.id",
            name: "voc_work_orders.name",
          })
          .from("voc_work_orders")
          .where((_: any) =>
            _.or([
              _.eq("voc_work_orders.name", _.const("Производство")),
              _.eq("voc_work_orders.name", _.const("производство")),
            ]),
          )
          .limit(1),
      ]);
      const docs = result.getOperation(QNAME).getContent().documents || [];
      const item = docs[0];
      if (!item) return;
      c.saveMeta = {
        ...c.saveMeta,
        work_order_id: item.id,
        work_order_name: item.name || "Производство",
      };
      if (process.env.NODE_ENV === "development") {
        console.debug(
          "[Calculator] default work_order set",
          c.saveMeta.work_order_id,
        );
      }
    } catch (err) {
      console.error("[Calculator] failed to set default work_order", err);
    }
  }

  private async ensureDefaultAtomLine() {
    const c = this as any;
    if (c.saveMeta?.line_id) return;
    const QNAME = "CALC_DEFAULT_LINE";
    try {
      const result = await (this as any).$db([
        (this as any)
          .$q(QNAME)
          .select()
          .fileds({
            id: "voc_lines.id",
            name: "voc_lines.name",
          })
          .from("voc_lines")
          .where((_: any) =>
            _.and([
              _.eq("voc_lines.name", _.const("АТОМ 500")),
              _.eq("voc_lines.templates", _.const("atom")),
            ]),
          )
          .limit(1),
      ]);
      const docs = result.getOperation(QNAME).getContent().documents || [];
      const item = docs[0];
      if (!item) return;
      c.saveMeta = {
        ...c.saveMeta,
        line_id: item.id,
      };
      if (process.env.NODE_ENV === "development") {
        console.debug("[Calculator] default line set", c.saveMeta.line_id);
      }
    } catch (err) {
      console.error("[Calculator] failed to set default line", err);
    }
  }

  @Watch("activeTab")
  onActiveTabChange(tab: number) {
    if (tab === 1) {
      (this as any).historyPage = 1;
      (this as any).loadHistoryNow();
    }
  }

  @Watch("saveMeta.calculation_datetime")
  onCalculationDatetimeChange(newVal: any, oldVal: any) {
    const n =
      newVal != null && moment(newVal).isValid()
        ? moment(newVal).format("YYYY-MM-DD")
        : null;
    const o =
      oldVal != null && moment(oldVal).isValid()
        ? moment(oldVal).format("YYYY-MM-DD")
        : null;
    if (n === o) return;
    if (process.env.NODE_ENV === "development") {
      console.debug("[Calculator] calculation_datetime calendar date changed", {
        n,
        o,
      });
    }
    this.$store.dispatch(`${STORE_KEY}/loadShiftWorkers`, null);
    const c = this as any;
    c.saveMeta = {
      ...c.saveMeta,
      shift_id: null,
      shift_label: null,
      master_employee_id: null,
      master_name: null,
      prepared_by_employee_ids: [],
    };
  }

  opendeSources: any[] = [];

  milkstabCalc() {
    this.resultMilkstab = (this.input.weight * this.input.p_add_milkstab) / 100;
  }

  private toFiniteNumber(value: unknown): number | null {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  private isEffectivelyZero(value: unknown): boolean {
    const n = this.toFiniteNumber(value);
    return n != null && Math.abs(n) < 1e-9;
  }

  private shouldHideCalculatedIngredient(key: string, item: any): boolean {
    if (item == null || typeof item !== "object") return false;
    if (!item.ingredient || typeof item.ingredient !== "object") return false;
    if (
      key === "m_cheese_before" ||
      key === "sum_backet" ||
      key === "middle_pH"
    ) {
      return false;
    }
    return this.isEffectivelyZero(item.value);
  }

  private getVisibleResultEntriesFrom(resultObj: any): Array<[string, any]> {
    if (!resultObj || typeof resultObj !== "object") return [];
    return Object.entries(resultObj).filter(([key, item]) => {
      return !this.shouldHideCalculatedIngredient(key, item);
    });
  }

  get visibleResultEntries(): Array<{ key: string; item: any }> {
    return this.getVisibleResultEntriesFrom(this.result).map(([key, item]) => ({
      key,
      item,
    }));
  }

  get fullResult() {
    return (
      Object.values(this.result).filter((item: any) => {
        return (
          isNaN(item) && item != null && item != undefined && !isObject(item)
        );
      }).length == 0 &&
      this.input.after_product &&
      (this.input.before_product || this.is_first)
    );
  }

  setInput(field: string, $event: any) {
    this.input[field] = $event;
    this.weightCalc();
  }

  weightCalc() {
    if (this.input.after_product) {
      const plan: any = {
        common_weight: this.input.common_weight,
        reprocessing_weight: this.input.reprocessing_weight || 0,
        ...this.input.after_product,
        journals: [
          {
            palet_weight: this.input.pallet_weight,
          },
        ],
        quantites: {
          backet_1_class: this.input.backet_1_class,
          backet_2_class: this.input.backet_2_class,
          backet_3_class: this.input.backet_3_class,
          backet_4_class: this.input.backet_4_class,
          backet_5_class: this.input.backet_5_class,
          backet_6_class: this.input.backet_6_class,
          backet_7_class: this.input.backet_7_class,
        },
      };
      if (!this.is_first) {
        plan.prev = this.input.before_product;
      }
      const _sort_mapper: any = {
        m_cheese_before: -3,
        sum_backet: -2,
        middle_pH: -1,
      };
      this.$store
        .dispatch(`${STORE_KEY}/weightCalc`, plan)
        .then((resp: any) => {
          const result = Object.keys(resp)
            .sort((a: any, b: any) => {
              const keyA = _sort_mapper[a] ? _sort_mapper[a] : 0;
              const keyB = _sort_mapper[b] ? _sort_mapper[b] : 0;
              console.log(keyA, keyB, a, b);
              const result = keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
              return result;
            })
            .reduce((acc: any, key: any) => {
              acc[key] = resp[key];
              return acc;
            }, {});
          if (process.env.NODE_ENV === "development") {
            const sumBacket = Number(result?.sum_backet?.value || 0);
            const reprocessing = Number(this.input.reprocessing_weight || 0);
            const visibleEntries = this.getVisibleResultEntriesFrom(result);
            const totalEntries = Object.keys(result || {}).length;
            console.debug("[Calculator] total mass with reprocessing", {
              base: sumBacket,
              reprocessing,
              total: result?.sum_backet?.value,
            });
            console.debug("[Calculator] hide zero ingredients", {
              totalEntries,
              visibleEntries: visibleEntries.length,
              hiddenEntries: Math.max(totalEntries - visibleEntries.length, 0),
            });
          }
          this.result = result;
        });
    }
  }

  weightCalc_old() {
    this.result = {};
    if (!this.input.after_product || !this.input.before_product) {
      if (!this.is_first) {
        return;
      }
    }

    const backet_weight = 0.432;

    const common_weight = this.input.common_weight;
    const pallet_weight = this.input.pallet_weight;
    const quantity_backets_1_class = this.input.backet_1_class;
    const quantity_backets_2_class = this.input.backet_2_class;
    const quantity_backets_3_class = this.input.backet_3_class;
    const quantity_backets_4_class = this.input.backet_4_class;
    const quantity_backets_5_class = this.input.backet_5_class;
    const quantity_backets_6_class = this.input.backet_6_class;
    const quantity_backets_7_class = this.input.backet_7_class;
    const labels: any = {};

    const quantity_backets =
      quantity_backets_1_class +
      quantity_backets_2_class +
      quantity_backets_3_class +
      quantity_backets_4_class +
      quantity_backets_5_class +
      quantity_backets_6_class +
      quantity_backets_7_class;

    const basket_volumes = [
      quantity_backets_1_class / quantity_backets,
      quantity_backets_2_class / quantity_backets,
      quantity_backets_3_class / quantity_backets,
      quantity_backets_4_class / quantity_backets,
      quantity_backets_5_class / quantity_backets,
      quantity_backets_6_class / quantity_backets,
      quantity_backets_7_class / quantity_backets,
    ];

    const after_product_ingredients: any = this.input.after_product.ingredients.reduce(
      (acc: any, item: any) => {
        labels[item.code] = { name: item.name, type: item.type };
        acc[item.code] = 0;
        acc[item.code] +=
          (quantity_backets_1_class > 0
            ? parseFloat(item.value_time_1 || 0)
            : 0) * basket_volumes[0];
        acc[item.code] +=
          (quantity_backets_2_class > 0
            ? parseFloat(item.value_time_2 || 0)
            : 0) * basket_volumes[1];
        acc[item.code] +=
          (quantity_backets_3_class > 0
            ? parseFloat(item.value_time_3 || 0)
            : 0) * basket_volumes[2];
        acc[item.code] +=
          (quantity_backets_4_class > 0
            ? parseFloat(item.value_time_4 || 0)
            : 0) * basket_volumes[3];
        acc[item.code] +=
          (quantity_backets_5_class > 0
            ? parseFloat(item.value_time_5 || 0)
            : 0) * basket_volumes[4];
        acc[item.code] +=
          (quantity_backets_6_class > 0
            ? parseFloat(item.value_time_6 || 0)
            : 0) * basket_volumes[5];
        acc[item.code] +=
          (quantity_backets_7_class > 0
            ? parseFloat(item.value_time_7 || 0)
            : 0) * basket_volumes[6];
        if (this.is_first && item.code == "strach") {
          acc[item.code] += parseFloat(this.input.after_product.strach_add);
        }
        return acc;
      },
      {},
    );

    const after_product_ingredients_ids: any = this.input.after_product.ingredients.reduce(
      (acc: any, item: any) => {
        acc[item.code] = item;
        return acc;
      },
      {},
    );

    const before_product_ingredients: any = this.input.before_product
      ? this.input.before_product.ingredients.reduce((acc: any, item: any) => {
          acc[item.code] = 0;
          acc[item.code] +=
            (quantity_backets_1_class > 0
              ? parseFloat(item.value_time_1 || 0)
              : 0) * basket_volumes[0];
          acc[item.code] +=
            (quantity_backets_2_class > 0
              ? parseFloat(item.value_time_2 || 0)
              : 0) * basket_volumes[1];
          acc[item.code] +=
            (quantity_backets_3_class > 0
              ? parseFloat(item.value_time_3 || 0)
              : 0) * basket_volumes[2];
          acc[item.code] +=
            (quantity_backets_4_class > 0
              ? parseFloat(item.value_time_4 || 0)
              : 0) * basket_volumes[3];
          acc[item.code] +=
            (quantity_backets_5_class > 0
              ? parseFloat(item.value_time_5 || 0)
              : 0) * basket_volumes[4];
          acc[item.code] +=
            (quantity_backets_6_class > 0
              ? parseFloat(item.value_time_6 || 0)
              : 0) * basket_volumes[5];
          acc[item.code] +=
            (quantity_backets_7_class > 0
              ? parseFloat(item.value_time_7 || 0)
              : 0) * basket_volumes[6];
          return acc;
        }, {})
      : {};

    let remainder = 0;
    if (
      before_product_ingredients &&
      before_product_ingredients.remainders &&
      before_product_ingredients.remainders.data
    ) {
      remainder =
        before_product_ingredients.remainders.data[
          after_product_ingredients.id
        ];
    }

    const m_cheese_before = remainder > 0 ? remainder : this.is_first ? 0 : 70;

    const PH_backets_1_class = 4.95; // parseFloat(after_product_ingredients.PH_backets_1_class);
    const PH_baсkets_2_class = 4.9; // parseFloat(after_product_ingredients.PH_baсkets_2_class);
    const PH_baсkets_3_class = 4.85; // parseFloat(after_product_ingredients.PH_baсkets_3_class);
    const PH_baсkets_4_class = 4.8; // parseFloat(after_product_ingredients.PH_baсkets_3_class);
    const PH_baсkets_5_class = 4.8; // parseFloat(after_product_ingredients.PH_baсkets_3_class);
    const PH_baсkets_6_class = 4.8; // parseFloat(after_product_ingredients.PH_baсkets_3_class);
    const PH_baсkets_7_class = 4.8; // parseFloat(after_product_ingredients.PH_baсkets_3_class);

    const sum_backet =
      common_weight -
      pallet_weight -
      backet_weight * Number(quantity_backets) +
      this.input.after_product.ingredients.reduce((sum: number, item: any) => {
        if (item.type == "g") {
          sum +=
            quantity_backets_1_class > 0
              ? parseFloat(item.value_time_1 || 0)
              : 0;
          sum +=
            quantity_backets_2_class > 0
              ? parseFloat(item.value_time_2 || 0)
              : 0;
          sum +=
            quantity_backets_3_class > 0
              ? parseFloat(item.value_time_3 || 0)
              : 0;
          sum +=
            quantity_backets_4_class > 0
              ? parseFloat(item.value_time_4 || 0)
              : 0;
          sum +=
            quantity_backets_5_class > 0
              ? parseFloat(item.value_time_5 || 0)
              : 0;
          sum +=
            quantity_backets_6_class > 0
              ? parseFloat(item.value_time_6 || 0)
              : 0;
          sum +=
            quantity_backets_7_class > 0
              ? parseFloat(item.value_time_7 || 0)
              : 0;
        }
        return sum;
      }, 0) /
        1000;

    const deltas = Object.keys(after_product_ingredients).reduce(
      (acc: any, key: any) => {
        acc[key] = 0;
        if (!this.is_first && before_product_ingredients) {
          acc[key] =
            (parseFloat(after_product_ingredients[key]) || 0) -
            before_product_ingredients[key];
        } else {
          before_product_ingredients[key] = 0;
        }
        return acc;
      },
      {},
    );

    console.log(deltas);

    const middle_pH =
      (quantity_backets_1_class * PH_backets_1_class +
        quantity_backets_2_class * PH_baсkets_2_class +
        quantity_backets_3_class * PH_baсkets_3_class +
        quantity_backets_4_class * PH_baсkets_4_class +
        quantity_backets_5_class * PH_baсkets_5_class +
        quantity_backets_6_class * PH_baсkets_6_class +
        quantity_backets_7_class * PH_baсkets_7_class) /
      quantity_backets;

    const milkstab = this.consts.milkstab.filter((item: any) => {
      return middle_pH > item.min && middle_pH <= item.max;
    });
    const p_milkstab = (milkstab.length > 0
      ? milkstab
      : this.consts.milkstab)[0].value;

    const p_cheese =
      100 -
      this.input.after_product.ingredients.reduce((sum: number, item: any) => {
        if (
          item.type == "p" &&
          !["strach_b152", "strach_purity87"].includes(item.code)
        ) {
          sum +=
            (quantity_backets_1_class > 0
              ? parseFloat(item.value_time_1 || 0)
              : 0) * basket_volumes[0];
          sum +=
            (quantity_backets_2_class > 0
              ? parseFloat(item.value_time_2 || 0)
              : 0) * basket_volumes[1];
          sum +=
            (quantity_backets_3_class > 0
              ? parseFloat(item.value_time_3 || 0)
              : 0) * basket_volumes[2];
          sum +=
            (quantity_backets_4_class > 0
              ? parseFloat(item.value_time_4 || 0)
              : 0) * basket_volumes[3];
          sum +=
            (quantity_backets_5_class > 0
              ? parseFloat(item.value_time_5 || 0)
              : 0) * basket_volumes[4];
          sum +=
            (quantity_backets_6_class > 0
              ? parseFloat(item.value_time_6 || 0)
              : 0) * basket_volumes[5];
          sum +=
            (quantity_backets_7_class > 0
              ? parseFloat(item.value_time_7 || 0)
              : 0) * basket_volumes[6];
        }
        return sum;
      }, 0);

    const m_milkstab = (p_milkstab * sum_backet) / p_cheese;

    const result: any = {};

    result.m_cheese_before = {
      label: "Переходящий остаток",
      value: m_cheese_before,
      type: "simple",
    };

    result.sum_backet = {
      label: "Общая масса, кг",
      value: sum_backet + m_cheese_before,
      type: "simple",
      inner: [
        {
          label: "Процент, %",
          value: p_cheese,
        },
        {
          label: "Масса нетто сгустков, кг",
          value:
            common_weight -
            pallet_weight -
            backet_weight * Number(quantity_backets),
        },
      ],
    };

    result.middle_pH = {
      label: "Средневзвешенная рН",
      value: Math.floor(middle_pH * 100) / 100,
      type: "simple",
    };

    const ingredientSortScore = (code: string) => {
      const ing = after_product_ingredients_ids[code];
      if (!ing || typeof ing !== "object") return 0;
      const raw = Number(
        ing.raw_material_position != null
          ? ing.raw_material_position
          : ing.raw_material != null && ing.raw_material.position != null
          ? ing.raw_material.position
          : undefined,
      );
      const sub = Number(
        ing.subgroup_position != null
          ? ing.subgroup_position
          : ing.subgroup != null && ing.subgroup.position != null
          ? ing.subgroup.position
          : undefined,
      );
      const r = Number.isFinite(raw) ? raw : 0;
      const s = Number.isFinite(sub) ? sub : 0;
      return r * 100 + s;
    };

    const sortedIngredientKeys = Object.keys(after_product_ingredients).sort(
      (a: string, b: string) => {
        const sa = ingredientSortScore(a);
        const sb = ingredientSortScore(b);
        if (sa !== sb) return sa - sb;
        return a.localeCompare(b, "ru");
      },
    );

    sortedIngredientKeys.forEach((key: any) => {
      let value = 0;
      let percent = 0;
      let base = sum_backet + m_cheese_before;
      let delta = deltas[key];
      if (labels[key].type == "p") {
        if (["strach_b152", "strach_purity87"].includes(key)) {
          base = result["starch"];
        }
        delta = m_cheese_before * before_product_ingredients[key] * 10;
        const common = after_product_ingredients[key] * base * 10;
        const _percent = ((common - delta) / 100 / sum_backet) * 10;
        value = ((sum_backet * _percent) / p_cheese) * 1000;
        percent = after_product_ingredients[key];
      } else {
        value = after_product_ingredients[key];
        percent =
          after_product_ingredients[key] / 10 / (sum_backet + m_cheese_before);
      }
      result[key] = {
        label: labels[key].name,
        percent: percent,
        value: value,
        deltas: delta,
        type: labels[key].type,
      };
    });
    result.strach_purity87.value =
      (after_product_ingredients["strach_purity87"] * result.strach.value) /
      100;
    result.strach_purity87.deltas =
      (after_product_ingredients["strach_purity87"] * result.strach.deltas) /
      100;
    result.strach_b152.value =
      (after_product_ingredients["strach_b152"] * result.strach.value) / 100;
    result.strach_b152.deltas =
      (after_product_ingredients["strach_b152"] * result.strach.deltas) / 100;

    this.result = result;
  }
}
